import type { FC } from 'react';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import DreamUpStarsIcon from '@wix/da-ds/pkg/Icons/24x24/DreamUpStars';
import useDreamUpButtonProps from './useDreamUpButtonProps';
import TextButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/TextButtonWithContextMenu';
import { Url } from '@wix/da-url';
import { BiData, EditWithMuroBiEvent } from '@wix/da-bi/pkg/events';
import { usePushMiniMobileMuroModal } from '@wix/da-shared-react/pkg/utils/hooks/usePushMuroModal';

export interface Props {
  className?: string;
}

const CreateDropdown: FC<PropsWithChildren<Props>> = ({ className }) => {
  const { t } = useTranslation();
  const dreamupButtonProps = useDreamUpButtonProps();

  const pushMobileMuroModal = usePushMiniMobileMuroModal();

  return (
    <TextButtonWithContextMenu
      variant="main"
      size="large"
      className={className}
      icon={DreamUpStarsIcon}
      items={[
        {
          label: t('browse.dreamupCTA.mobile'),
          link: Url.dreamupLink(),
          biData: dreamupButtonProps.biData,
        },
        {
          label: t('browse.button.draw'),
          onClick: pushMobileMuroModal,
          biData: BiData<EditWithMuroBiEvent>({
            evid: 926,
            page_typeid: undefined,
            page_itemid: undefined,
            sectionname: 'general',
          }),
        },
      ]}
    >
      {t('browse.button.create')}
    </TextButtonWithContextMenu>
  );
};

CreateDropdown.displayName = 'CreateDropdown';
export default CreateDropdown;
